import React from 'react'
import Grid from "@blocks/Grid"
import useLoading from "@hooks/useLoading"
import { useCallback } from "react"
import { Ring } from '@blocks/Loading'
import Input from '@blocks/Input'
import _ from 'lodash'
import { useVotingDashboardContext } from '../../../context'
import { useSalonManagerContext } from '@admin/components/templates/SalonManager/context'

export default function VotingLimit(section: Admin.Resources.DashboardSection) {
    const loading = useLoading()
    const { salon } = useSalonManagerContext()
    const { voting } = useVotingDashboardContext()

    const debouncedStore = useCallback(
        _.debounce(async (number: string) => {
            loading.until(async () => {
                await salon.api.limit.store([{ section_id: section.id, number: parseInt(number) }])
                await voting.fresh()
            })
        }, 500), []
    )

    const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => debouncedStore(e.target.value)

    return (
        <Grid gap="10px">
            <h4>{section.name}</h4>
            <Input
                min="0"
                max={salon.attrs.maxScore()}
                defaultValue={section.limit?.number || "0"}
                background="#fff"
                onChange={handleChange}
                id={`limit-${section.id}`}
                name={`limit-${section.id}`}
                type="number" />
            {loading.state
                ? <Ring />
                : (
                    <Grid gap="5px">
                        <small>Acceptances</small>
                        <h5>{section.acceptances_count} / {section.participations_count} ({Math.round(section.acceptances_count / section.participations_count * 100) || 0}%)</h5>
                    </Grid>
                )
            }
        </Grid>
    )
}